// src/SendMessageForm.js
import React, { useState } from 'react';
import { db, storage } from './firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { addDoc, collection } from 'firebase/firestore';
import { TextField, Button, RadioGroup, FormControlLabel, Radio, FormGroup, Checkbox, Typography, Box, Paper, CircularProgress, Alert } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';

function SendMessageForm({ user, recipientList, senderName = 'Usuário' }) {
    const [messageText, setMessageText] = useState('');
    const [imageFile, setImageFile] = useState(null);
    const [recipients, setRecipients] = useState([]);
    const [sendToAll, setSendToAll] = useState(true);
    const [isSending, setIsSending] = useState(false);
    const [feedback, setFeedback] = useState({ type: '', message: '' });

    const handleFileChange = (e) => setImageFile(e.target.files[0]);
    const handleRecipientChange = (e) => {
        const { value, checked } = e.target;
        setRecipients(prev => checked ? [...prev, value] : prev.filter(id => id !== value));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!messageText) return setFeedback({ type: 'error', message: 'A mensagem não pode estar vazia.' });
        
        const finalRecipients = sendToAll ? recipientList.map(u => u.id) : recipients;
        if (finalRecipients.length === 0) return setFeedback({ type: 'error', message: 'Selecione pelo menos um destinatário.' });

        setIsSending(true);
        setFeedback({ type: 'info', message: 'Enviando...' });

        try {
            let imageUrl = null;
            if (imageFile) {
                const storageRef = ref(storage, `messages/${Date.now()}_${imageFile.name}`);
                const snapshot = await uploadBytes(storageRef, imageFile);
                imageUrl = await getDownloadURL(snapshot.ref);
            }
            await addDoc(collection(db, 'mensagens'), {
                remetenteId: user.uid, remetenteNome: senderName,
                destinatarios: finalRecipients, mensagemTexto: messageText,
                imagemUrl: imageUrl, dataEnvio: new Date(),
            });
            setFeedback({ type: 'success', message: 'Mensagem enviada com sucesso!' });
            setMessageText(''); setImageFile(null); setRecipients([]); e.target.reset();
        } catch (error) {
            setFeedback({ type: 'error', message: 'Erro ao enviar mensagem.' });
        } finally {
            setIsSending(false);
        }
    };

    return (
        <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>Enviar Nova Mensagem</Typography>
            <Box component="form" onSubmit={handleSubmit}>
                <TextField fullWidth multiline rows={4} label="Mensagem" value={messageText} onChange={(e) => setMessageText(e.target.value)} sx={{ mb: 2 }} />
                <Button variant="outlined" component="label" startIcon={<UploadFileIcon />}>Anexar Arquivo
                    <input type="file" hidden onChange={handleFileChange} />
                </Button>
                {imageFile && <Typography variant="body2" sx={{ ml: 1, display: 'inline' }}>{imageFile.name}</Typography>}
                <RadioGroup row value={sendToAll.toString()} onChange={(e) => setSendToAll(e.target.value === 'true')} sx={{ mt: 2 }}>
                    <FormControlLabel value="true" control={<Radio />} label="Enviar para todos na lista" />
                    <FormControlLabel value="false" control={<Radio />} label="Selecionar" />
                </RadioGroup>
                {!sendToAll && (
                    <Paper variant="outlined" sx={{ maxHeight: 150, overflow: 'auto', p: 1, mt: 1 }}>
                        <FormGroup>
                            {recipientList.filter(u => u.id !== user.uid).map(u => (<FormControlLabel key={u.id} control={<Checkbox value={u.id} onChange={handleRecipientChange} />} label={`${u.nome} (${u.tipoUsuario})`} />))}
                        </FormGroup>
                    </Paper>
                )}
                <Button type="submit" variant="contained" disabled={isSending} fullWidth sx={{ mt: 2 }}>
                    {isSending ? <CircularProgress size={24} /> : 'Enviar Mensagem'}
                </Button>
                {feedback.message && <Alert severity={feedback.type} sx={{ mt: 2 }}>{feedback.message}</Alert>}
            </Box>
        </Paper>
    );
}

export default SendMessageForm;